<template>
  <div class="eq-layout-main">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AppMain'
}
</script>
